module.exports = __webpack_public_path__ + "img/a2.8ae526e2.png";